import React from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { setLanguage, getLanguage, Language } from '@/utils/i18n-enhanced';

const LanguageSwitcher: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const currentLang = getLanguage();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang: Language) => {
    setLanguage(lang);
    handleClose();
    window.location.reload(); // Refresh to apply direction and translations globally
  };

  const languages: { code: Language; label: string; flag: string }[] = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'ar', label: 'العربية', flag: '🇸🇦' },
    { code: 'ar-MA', label: 'الدارجة', flag: '🇲🇦' },
  ];

  return (
    <Box>
      <Tooltip title="Switch Language">
        <IconButton
          onClick={handleOpen}
          color="inherit"
          sx={{ 
            bgcolor: 'rgba(197, 160, 89, 0.1)',
            color: 'primary.main',
            '&:hover': { bgcolor: 'rgba(197, 160, 89, 0.2)' }
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            minWidth: 150,
          },
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={currentLang === lang.code}
            sx={{ gap: 2, py: 1.5 }}
          >
            <Typography fontSize="1.2rem">{lang.flag}</Typography>
            <Typography variant="body2" sx={{ fontWeight: currentLang === lang.code ? 700 : 400 }}>
              {lang.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
